// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qlUz","label":"styles_label__1yGOt"};